module.exports = __webpack_public_path__ + "img/广州市白云区城市管理和综合执法局.daea0cc3.png";